import { Box, Flex, Stack } from "@chakra-ui/react";
import { PageFrame } from "components/frames/PageFrame";
import { ListSkeleton, Skeleton, TabsSkeleton } from "components/ui/skeleton";

type ExplorerSkeletonProps = {
  /** Sidebar column width of the page the skeleton stands in for, as a size token. */
  sidebarWidth: "64" | "80";
};

/**
 * Placeholder for the explorer while its tables and continuous aggregates
 * load: the sidebar view toggle over the schema list, and the content column
 * beside it. Mirrors the page layout so nothing shifts when the objects land.
 */
export const ExplorerSkeleton = ({ sidebarWidth }: ExplorerSkeletonProps) => (
  <Flex
    direction={{ base: "column", xl: "row" }}
    gap={{ base: "8", xl: "6" }}
    aria-busy
    data-cy="explorer-skeleton"
  >
    <Stack
      as="aside"
      gap="4"
      width={{ base: "full", xl: sidebarWidth }}
      flexShrink={0}
    >
      <Skeleton height="8" width="full" />
      <ListSkeleton rows={8} lines={1} />
    </Stack>
    <Flex direction="column" flex="1" minW={0}>
      <Box mb="4">
        <TabsSkeleton />
      </Box>
      <Box
        p="4"
        border="1px solid"
        borderColor="border.container"
        borderRadius="2xl"
      >
        <ListSkeleton rows={5} />
      </Box>
    </Flex>
  </Flex>
);

/**
 * The Explorer's route skeleton. It carries the frame the loaded page has, so
 * the content does not shift when the page replaces it.
 */
export const ExplorerRouteSkeleton = () => (
  <PageFrame>
    <ExplorerSkeleton sidebarWidth="80" />
  </PageFrame>
);
